import { Injectable } from '@angular/core';
import { Report } from '../models/report';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {HttpService} from "./http.service";

@Injectable()
export class ReportsService {
    constructor(
        private httpService: HttpService,
        private toastr: ToastsManager
    ) {}

    getBaseReports(from: string, to: string, machines: string): Promise<Report>{
    	let me = this;
    	return this.httpService.get(`/Reports`, {from: from, to: to, machines: machines})
    		.then(function(results: any){
    			return new Report().fromJson(results)
    		})
    		.catch(function(error: any){
    			me.httpService.handleError(error, "Unable to connect to the server")
    		})
    }

	sendEmail(from: string, to: string, machines: string, toAddress: string): Promise<any> {
		let me = this;
		return this.httpService.get(`/Reports/email`, {from: from, to: to, machines: machines, toAddress: toAddress})
			.then(function(results: any){
				me.toastr.success("Email Sent");
				return {}
			})
			.catch(function(error: any){
				me.httpService.handleError(error, "Unable to email Report")
			})
	}

	getReportDownloadUrl(from: string, to: string, machines: string): string {
		return `${this.httpService.baseUrl}/Reports/pdf?from=${from}&to=${to}&machines=${machines}&access_token=${this.httpService.accessToken}`;
	}

}



// WEBPACK FOOTER //
// ./src/app/services/reports.service.ts